import type { FC } from 'react';

import { Booking } from '@mopla/data-models';
import { calculateBookingExtraPassengers } from '@mopla/utils';

import { PassengerBookingInfo } from '../../atoms/PassengerBookingInfo';

import { Root } from './PassengerCheckedList.styles';

export interface IPassengerCheckedListProps {
	bookings: Booking[];
	highlighted?: boolean;
	testId?: string;
}

export const PassengerCheckedList: FC<IPassengerCheckedListProps> = ({
	bookings,
	highlighted = true,
	testId,
}) => (
	<Root data-testid={testId}>
		{bookings.map((booking: Booking) => {
			const mainPassenger = booking.passengerList.find(
				(pass) => pass.isMainPassenger
			);
			const otherPassengers = calculateBookingExtraPassengers(booking);

			let fullName = '';

			if (mainPassenger) {
				const { firstName, lastName } = mainPassenger;
				fullName = `${firstName} ${lastName}`;
			}

			return (
				<PassengerBookingInfo
					key={booking.bookingId}
					mainPassengerFullName={fullName}
					additionalPassengersCount={otherPassengers}
					bookingId={booking.bookingId}
					highlighted={highlighted}
					hasSeparator
				/>
			);
		})}
	</Root>
);
